import { Card, CardContent, Typography } from "@mui/material";
import { PieChart } from "@mui/x-charts/PieChart";

const venueCapacityData = [
  { id: 0, value: 55.1, label: "Hall" },
  { id: 1, value: 18.3, label: "Chapel" },
  { id: 2, value: 15.2, label: "Church" },
  { id: 3, value: 7.6, label: "Tent" },
  { id: 4, value: 3.8, label: "Funeral Parlour" },
];

export default function VenueCapacityWidget() {
  return (
    <Card sx={{ height: "100%", borderRadius: 3, width: "100%" }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Venue Type by Capacity
        </Typography>

        <PieChart
          series={[
            {
              data: venueCapacityData,
              innerRadius: 70,
              outerRadius: 110,
              paddingAngle: 2,
            },
          ]}
          height={302}
        />
      </CardContent>
    </Card>
  );
}
